import { Link } from "react-router-dom";
import styles from "../styles/pages.module.css";

export default function MudanzasChamberi() {
  return (
    <div className={styles.legalPage}>
      <div className={styles.legalContainer}>
        <h1>Mudanzas en Chamberí, Madrid</h1>
        <span className={styles.lastUpdated}>Mudanzas cuidadosas en uno de los barrios más emblemáticos de Madrid</span>

        <div style={{ textAlign: "center", margin: "1.5rem 0" }}>
          <img
            src="/assets/images/distrito-chamberi.webp"
            alt="Mudanzas en Chamberí"
            style={{ maxWidth: "100%", borderRadius: "8px", boxShadow: "0 4px 12px rgba(0,0,0,0.1)" }}
          />
        </div>

        <p>
          <strong>Chamberí</strong> es sinónimo de arquitectura señorial, amplios pisos con techos altos y familias que buscan un traslado sin contratiempos. En Britosa entendemos que mudarse en este distrito requiere un nivel de cuidado superior: suelos de parquet, escaleras de mármol, ascensores antiguos y muebles de calidad que merecen trato de excelencia.
        </p>

        <h2>Mudanzas de calidad para familias exigentes</h2>
        <p>
          Nuestro equipo está especializado en mudanzas de alto standing. Utilizamos materiales de embalaje premium, protectores de suelos y puertas, y técnicas de porteo que garantizan que cada pieza llegue a su destino en perfectas condiciones. Si tienes obras de arte, antigüedades o un piano de cola, disponemos de técnicos especializados.
        </p>

        <h2>Servicios en Chamberí y alrededores</h2>
        <ul>
          <li><strong>Mudanzas residenciales:</strong> Pisos, áticos y chalets adosados en Chamberí, Almagro, Trafalgar y Ríos Rosas.</li>
          <li><strong>Mudanzas de lujo:</strong> Embalaje premium, seguro ampliado y supervisión directa del jefe de equipo.</li>
          <li><strong>Montaje de muebles:</strong> Desmontaje en origen y montaje en destino por carpinteros cualificados.</li>
          <li><strong>Guardamuebles:</strong> Almacenaje en instalaciones vigiladas si necesitas tiempo para entrar en tu nueva vivienda.</li>
        </ul>

        <h2>Conocemos Chamberí al detalle</h2>
        <p>
          Desde la Plaza de Chamberí hasta el Paseo de la Castellana, pasando por Calle Fuencarral y la zona de Alonso Martínez. Sabemos dónde aparcar, cómo acceder a patios interiores y cuál es la mejor franja horaria para evitar atascos en la zona.
        </p>

        <div style={{ background: "#f0f9ff", borderRadius: "8px", padding: "1.25rem", margin: "1.5rem 0", border: "1px solid #bae6fd" }}>
          <h3 style={{ marginTop: 0, color: "#0F4C75" }}>Mudanza en Chamberí sin preocupaciones</h3>
          <p style={{ marginBottom: "1rem" }}>
            Solicita tu presupuesto personalizado. Valoramos in situ si es necesario.
          </p>
          <Link to="/presupuesto" style={{ display: "inline-block", padding: "0.6rem 1.4rem", background: "#F97316", color: "#fff", borderRadius: "6px", textDecoration: "none", fontWeight: 600 }}>
            Pedir presupuesto →
          </Link>
        </div>

        <p style={{ fontSize: "0.85rem", color: "#6b7280", marginTop: "2rem" }}>
          Contacto directo: <a href="tel:+34691604880">691 60 48 80</a> · <a href="mailto:info@mudanzasbritosa.com">info@mudanzasbritosa.com</a>
        </p>
      </div>

      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "name": "Britosa Mudanzas - Chamberí",
          "description": "Mudanzas profesionales en Chamberí, Madrid. Especialistas en traslados de calidad y embalaje premium.",
          "url": "https://mudanzasbritosa.com/mudanzas-chamberi",
          "telephone": "+34691604880",
          "email": "info@mudanzasbritosa.com",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "C. Río Duero, 28934 Móstoles",
            "addressLocality": "Chamberí, Madrid",
            "addressRegion": "Madrid",
            "addressCountry": "ES"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 40.4346,
            "longitude": -3.6976
          },
          "areaServed": {
            "@type": "City",
            "name": "Chamberí"
          },
          "priceRange": "€€",
          "openingHours": "Mo-Su 08:00-22:00"
        })
      }} />
    </div>
  );
}
